import {announce} from '@github-ui/aria-live'
import {Spinner} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import {useEffect} from 'react'

const AUTO_REFRESH_MS = 10000

export interface CreatingStateProps {
  title: string
  description: string
}

/**
 * Spinner blankslate shown while a fork or mirror is being created.
 * Since we don't have real-time updates on the cloning progress,
 * we use a simple auto-refresh behavior by reloading the page
 * every ten seconds until the repo finishes cloning and is no
 * longer in this state.
 */
export function CreatingState({title, description}: CreatingStateProps) {
  useEffect(() => {
    announce(
      `This page will automatically refresh in ${AUTO_REFRESH_MS / 1000} seconds to check if the repository is ready.`,
    )

    const timeout = window.setTimeout(() => {
      window.location.reload()
    }, AUTO_REFRESH_MS)
    return () => window.clearTimeout(timeout)
  }, [])

  return (
    <Blankslate spacious>
      <Blankslate.Visual>
        <Spinner size="large" />
      </Blankslate.Visual>
      <Blankslate.Heading>{title}</Blankslate.Heading>
      <Blankslate.Description>{description}</Blankslate.Description>
    </Blankslate>
  )
}
